<template>
    <div class="mb-0 small">
        <template v-for="(link, id) in links.logoLinks">
            <a :key="`logo-link-${id}`" :href="link.link" target="_blank">
                <IconScribbrLogo :letters-color="`${grayTheme ? '#707DA7' : '#ffffff'}`"
                                 :icon-color="`${grayTheme ? '#707DA7' : '#F54E12'}`"
                                 :width="'6.25rem'"
                                 :height="'1.5rem'"
                />
            </a>
        </template>
        <ul class="list-unstyled mb-0" :class="{'gray-theme' : grayTheme}">
            <template v-for="(link, id) in links.logoLinks">
                <li :key="`logo-link-${id}`">
                    <strong>
                        <a class="navigation-link mb-1 d-inline-block strong"
                           :href="link.link"
                           target="_blank"
                           v-text="link.name"
                        />
                    </strong>
                </li>
            </template>

            <template v-for="(link, id) in links.otherLinks">
                <li :key="`link-${id}`">
                    <a class="navigation-link d-inline-block"
                       :href="link.link"
                       target="_blank"
                       v-text="link.name"
                    />
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import IconScribbrLogo from '../IconScribbrLogo/IconScribbrLogo';
export default {
    components: { IconScribbrLogo },
    props: {
        footerLinks: {
            type: Object,
            required: true,
            default: () => {},
        },
        grayTheme: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        links: function () {
            let logoLinks = [];
            let otherLinks = [];

            for (const property in this.footerLinks) {
                if (property === 'logo_link') {
                    this.footerLinks[property].map(link => logoLinks.push(link));
                } else {
                    this.footerLinks[property].map(link => otherLinks.push(link));
                }
            }
            return { logoLinks, otherLinks };
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';

.navigation-link {
  color: $gray-400;
  font-size: 0.875rem;
  &:hover {
     color: #ff7a00;
     text-decoration: none;
   }
}

.gray-theme {
    .navigation-link {
        color: $text-light;
        &:hover {
            color: #ff7a00;
            text-decoration: none;
        }
    }
}
</style>
